const extendedFieldDefaultCountries = [
  { label: "Antigua And Barbuda", id: "AG" },
  { label: "Australia", id: "AU" },
  { label: "Bahamas", id: "BS" },
  { label: "Canada", id: "CA" },
  { label: "Mexico", id: "MX" },
  { label: "Singapore", id: "SG" },
  { label: "United Arab Emirates", id: "AE" },
  { label: "United Kingdom", id: "UK" },
  { label: "United States", id: "US" },
];

export default extendedFieldDefaultCountries;
